import {
  get,
  internalDestroy,
  internalGet,
  internalPost,
  internalPut,
  unwrapListEnvelope,
} from '.';
import qs from 'qs';

// GET /internal/markets replaces the public POST /v1/markets/list. Response is
// { data, meta } (unwrapped below); markets carry a nested country
// { id, title, alpha2 }. Legacy `discardedAt`/`pageSize` filters map to
// `archived`/`perPage`, and the `order`/`direction` pair to `sort` (`name` or
// `country`, `-` prefix for descending); page 0 (sent by some dropdowns) means
// "no pagination".
export const getMarkets = ({ filters = {} }) => {
  const queryString = qs.stringify({
    search: filters.search || undefined,
    archived: filters.discardedAt ? true : undefined,
    page: filters.page || undefined,
    // v1 treated page/pageSize 0 as "no pagination" — dropdowns rely on it
    perPage: filters.perPage || filters.pageSize || 1000,
    sort: filters.order
      ? `${filters.direction === 'desc' ? '-' : ''}${filters.order}`
      : undefined,
  });

  return internalGet(`/markets?${queryString}`).then(unwrapListEnvelope);
};
export const getOneMarket = ({ marketId }) => get(`markets/${marketId}`);
export const createMarkets = (payload) => internalPost(`markets`, payload);
export const updateMarket = (marketId, payload) =>
  internalPut(`markets/${marketId}`, payload);
export const archiveMarket = (marketId) =>
  internalDestroy(`markets/${marketId}`);
